import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const TrustFactorBannerSchema: { [key: string]: IFormFieldType } = {
  trustFactorBanner: {
    type: 'Object',
    label: 'Trust Factor Banners',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      bannerImages: {
        type: 'List',
        label: 'Trust Factor Banners',
        required: false,
        children: {
          banner: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Banner',
            required: false,
          },
        },
      },
      backgroundPattern: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Background Pattern',
        required: false,
      },
    },
  },
}

export default TrustFactorBannerSchema

export type TrustFactorBannerProps = {
  heading: string
  bannerImages: {
    banner: string
  }[]
  backgroundPattern: string
}

export type TrustFactor = {
  trustFactorBanner: TrustFactorBannerProps
}

export const TrustFactorBannerDefaultValues: TrustFactor = {
  trustFactorBanner: {
    heading: 'Join Students From All Over India!',
    bannerImages: [
      {
        banner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/5cc54c7a-d211-4db6-9fde-b0365e21b37b.webp',
      },
      {
        banner:
          'https://static.pw.live/production-curiousjr-fundoo/static/images/trust-factor-banner/popular-ed-tech.svg',
      },
      {
        banner:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/1470d5bf-c06f-4b32-9248-39171d5078cf.webp',
      },
    ],
    backgroundPattern: 'https://static.pw.live/production-curiousjr-fundoo/static/images/patterns.jpeg',
  },
}
